import * as React from "react";
import { cn } from "@/lib/utils";

// Section eyebrow — uppercase kicker with a leading rule (deck pattern).
function Eyebrow({ className, children, ...props }) {
  return (
    <span data-kit="" className={cn("deck-eyebrow", className)} {...props}>
      {children}
    </span>
  );
}

// Page header — eyebrow + big tight title + subtitle, with an actions slot.
function PageHeader({ className, eyebrow, title, subtitle, actions, ...props }) {
  return (
    <div data-kit="" className={cn("mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between", className)} {...props}>
      <div className="space-y-1.5">
        {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
        {title ? <h1 className="text-[1.75rem] font-bold leading-tight tracking-[-0.02em] text-foreground">{title}</h1> : null}
        {subtitle ? <p className="max-w-2xl text-[15px] text-muted-foreground">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export { PageHeader, Eyebrow };
